<template>
  <div class="tab-container">
    <!-- ローディング -->
    <OverlayLoading
      :absoluteFlg="true"
      v-if="users.length === 0"/>
    <!-- 初期設定画面 -->
    <CalendarInit
      @googleAuthRedirect="googleAuthRedirect"
      @msofficeAuthRedirect="msofficeAuthRedirect"
      @changeModalCybozuOffice="changeModalCybozuOffice"
      @changeModalGaroon="changeModalGaroon"
      @changeModalGroupSession="changeModalGroupSession"
      @changeModalLineWorks="changeModalLineWorks"
      @changeModalNoLinkage="changeModalNoLinkage"
      v-if="!authType && !isScheduleLoading"/>
    <!-- モーダル部 start -->
    <!-- Cybozu Office モーダル -->
    <ModalCybozuOffice
      :isShowModal="isModalCybozuOffice"
      :authType="authType"
      :user="user"
      @cancel="changeModalCybozuOffice"
      @saveCybozuOffice="saveCybozuOffice"
      @delete-cybozuOffice="deleteCybozuOffice"
    v-if="isModalCybozuOffice"/>
    <!-- Garoon モーダル -->
    <ModalGaroon
      :isShowModal="isModalGaroon"
      :authType="authType"
      :user="user"
      @cancel="changeModalGaroon"
      @saveGaroonInit="saveGaroonInit"
      @saveGaroon="saveGaroon"
      @delete-garoon="deleteGaroon"
    v-if="isModalGaroon"/>
    <!-- LineWorks モーダル -->
    <ModalLineWorks
      :isShowModal="isModalLineWorks"
      :authType="authType"
      :user="user"
      @cancel="changeModalLineWorks"
      @saveLineWorks="saveLineWorks"
      @delete-lineworks="deleteLineWorks"
    v-if="isModalLineWorks"/>
    <!-- GroupSession モーダル -->
    <ModalGroupSession
      :isShowModal="isModalGroupSession"
      :authType="authType"
      :user="user"
      :saveGroupSession="saveGroupSession"
      :deleteGroupSession="deleteGroupSession"
      @cancel="changeModalGroupSession"
    v-if="isModalGroupSession"/>
    <!-- 連携なし モーダル -->
    <ModalNoLinkage
      :isShowModal="isModalNoLinkage"
      :authType="authType"
      :user="user"
      :saveNoLinkage="saveNoLinkage"
      :deleteNoLinkage="deleteNoLinkage"
      @cancel="changeModalNoLinkage"
    v-if="isModalNoLinkage"/>
    <!-- Google モーダル START -->
    <b-modal width="680px" :active.sync="isModalGoogle">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <div class="cover-filter">
            <p class="card-header-title title">
            Google Calendar 連携
            </p>
          </div>
        </header>
        <b-tabs position="is-left">
          <b-tab-item label="連携解除">
            <div class="card-content parent-box">
              <div class="box-request">
                <p style="text-align: left; padding: 15px;">
                  Google Calendarとの連携を解除しますか？<br/>
                  解除すると再設定が必要となります。<br/>
                </p>
                <hr>
                <a @click="googleAuthRevoke()" class="button is-primary">
                  連携を解除する
                </a>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item label="Driveのファイル保存先">
            <div class="card-content parent-box">
              <div v-if="isGoogleDriveAuth">
                <p style="text-align: left; font-weight: 600; padding-top: 16px;">保存先を選択</p>
                <div v-if="!isDriveInfoCreated">
                  <GoogleDriveFolderList
                    style="width: 100%; padding: 16px;"
                    :userId="user.userHash"
                    @set-folder="setFolder"
                  />
                </div>
                <div v-else>
                  <GoogleDriveFolderList
                    style="width: 100%; padding: 16px;"
                    :userId="user.userHash"
                    :folderId="drive_info.id"
                    :folderName="drive_info.name"
                    :mimeType="drive_info.mimeType"
                    :folderPath="drive_info.folderPath"
                    @set-folder="setFolder"
                  />
                </div>
                <b-field style="width: 100%">
                  <div style="width: 48%; align: left;">
                    <button class="button is-primary is-fullwidth"
                      @click="closeModalGoogle(false)"
                    >
                      閉じる
                    </button>
                  </div>
                  <div style="width: 5%;">
                  </div>
                  <div style="width: 48%; align: right;">
                    <template v-if="isDriveInfoCreated">
                      <button class="button is-primary is-fullwidth"
                        @click="createDriveInfo(); closeModalGoogle(false)"
                      >
                        更新する
                      </button>
                    </template>
                    <template v-else>
                      <button class="button is-primary is-fullwidth"
                        @click="createDriveInfo(); closeModalGoogle(false)"
                      >
                        保存する
                      </button>
                    </template>
                  </div>
                </b-field>
              </div>
              <div v-else>
                GoogleDriveと連携して添付ファイルの経由フォルダを設定してください。連携を行う場合は「設定」>
                「外部連携」 > 「GoogleDrive連携」より連携をお願いいたします。
              </div>
            </div>
          </b-tab-item>
        </b-tabs>
      </div>
    </b-modal>
    <!-- Google モーダル END -->
    <!-- MSOffice モーダル START -->
    <b-modal width="680px" :active.sync="isModalMSOffice">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <div class="cover-filter">
            <p class="card-header-title title">
            MS Office 365 Outlook Calendar 連携
            </p>
          </div>
        </header>
        <div class="card-content parent-box">
          <div class="box-request">
            <p style="text-align: left; padding: 15px;">
              MS Office 365 Outlook Calendarとの連携を解除しますか？<br/>
              解除すると再設定が必要となります。<br/>
            </p>
            <hr>
            <a @click="msofficeAuthRevoke()" class="button is-primary">
              連携を解除する
            </a>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- MSOffice モーダル END -->
    <!-- モーダル：イベント作成 -->
    <ModalCreateEvent 
      :isGoogleDriveAuth="isGoogleDriveAuth"
      :authType="authType"
      :userId="user.userHash"
      :drive_info="drive_info"
      :isCreated="isCreated"
      ref="create"
    />
    <!-- モーダル：イベント編集 -->
    <ModalEditEvent ref="edit"/>
    <!-- モーダル：マイカレンダー -->
    <ModalUserCalendarSetting ref="ucs"/>
    <!-- モーダル：お気に入り -->
    <ModalCalendarBookMark ref="cbm"/>
    <!-- モーダル部 end -->
    <!-- メイン：ヘッダー・ボディー -->
    <template v-if="$route.path.indexOf('/calendar/task') >= 0">
      <TaskView
        :authType="authType"
        :user="user"
        :users="users"
        :schedules="schedules"
        :eventGroup="eventGroup"
        :taskList="taskList"
        :calendarSettings="calendarSettings"
        :trelloBoardList="trelloBoardList"
        :trelloListList="trelloListList"
        :trelloCardList="trelloCardList"        
        :isSelfCheck="isSelfCheck"
        :isFileChanging="isFileChanging"
        :isScheduleLoading="isScheduleLoading"
        @changeTaskSchedules="changeTaskSchedules"
        @eventClick="eventClick"
        @openSettings="openSettings"
        @createEvent="createEvent"
        @createRecommendEvent="createRecommendEvent"
        @createUserTask="createUserTask"
        @updateUserTask="updateUserTask"
        @deleteUserTask="deleteUserTask"
        @createUserTaskFile="createUserTaskFile"
        @deleteUserTaskFile="deleteUserTaskFile"
        @sendUserTask="sendUserTask"
        @updateUserTaskLog="updateUserTaskLog"
      />
    </template>
    <template v-else>
      <DateView
        :authType="authType"
        :user="user"
        :users="users"
        :schedules="schedules"
        :calendarSettings="calendarSettings"
        :eventGroup="eventGroup"
        :isSelfCheck="isSelfCheck"
        :isScheduleLoading="isScheduleLoading"
        @changeSchedules="changeSchedules"
        @select="select"
        @eventClick="eventClick"
        @openSettings="openSettings"
        @createRecommendEvent="createRecommendEvent"
      />
    </template>
    <!-- サイドメニュー -->
    <CalendarSideMenu
      :user="user"
      :users="users"
      :usersStatusAPI="usersStatusAPI"
      :calendarSettings="calendarSettings"
      :calendarBookMarks="calendarBookMarks"
      :calendarEventHistory="calendarEventHistory"
      @changeShowEvent="changeShowEvent"
      @changeShowEventSelf="changeShowEventSelf"
      @ucsEditClick="ucsEditClick"
      @createCalendarBookMark="createCalendarBookMark"
      @clickEventFromHistory="clickEventFromHistory"
      @createCalendarSettings="createCalendarSettings"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import color from '@/assets/json/master/color.json'
import ModalEditEvent           from '@/components/Calendar/organisms/ModalEditEvent'
import ModalCreateEvent         from '@/components/Calendar/organisms/ModalCreateEvent'
import ModalUserCalendarSetting from '@/components/Calendar/organisms/ModalUserCalendarSetting'
import ModalCalendarBookMark    from '@/components/Calendar/organisms/ModalCalendarBookMark'
import ModalCybozuOffice        from '@/components/Calendar/organisms/ModalCybozuOffice'
import ModalGaroon              from '@/components/Calendar/organisms/ModalGaroon'
import ModalGroupSession        from '@/components/Calendar/organisms/ModalGroupSession'
import ModalLineWorks           from '@/components/Calendar/organisms/ModalLineWorks'
import ModalNoLinkage           from '@/components/Calendar/organisms/ModalNoLinkage'
import CalendarSideMenu         from '@/components/Calendar/organisms/CalendarSideMenu'
import CalendarInit             from '@/views/DashBoard/Calendar/CalendarInit'
import DateView                 from '@/views/DashBoard/Calendar/DateView'
import TaskView                 from '@/views/DashBoard/Calendar/TaskView'
import OverlayLoading           from '@/components/animations/OverlayLoading'
import GoogleDriveFolderList from '@/components/organisms/common/GoogleDriveFolderList'
import hex2rgb from '@/functions/hex2rgb'
// 外部関数
import {
  autoColor
} from '@/functions/balloonFunc'
export default {
  components: {
    ModalEditEvent,
    ModalCreateEvent,
    ModalUserCalendarSetting,
    ModalCalendarBookMark,
    OverlayLoading,
    ModalCybozuOffice,
    CalendarSideMenu,
    ModalGaroon,
    ModalGroupSession,
    ModalLineWorks,
    ModalNoLinkage,
    CalendarInit,
    DateView,
    TaskView,
    GoogleDriveFolderList
  },
  data () {
    return {
      isSelfCheck: true,
      authType: '',
      colorList: color,
      selectDate: 'today',
      selected: {},
      calendar: null,
      viewType: '週',
      nowTime: null,
      isModalGaroon: false,
      isModalGoogle: false,
      isModalCybozuOffice: false,
      isModalMSOffice: false,
      isModalGroupSession: false,
      isModalLineWorks: false,
      isModalNoLinkage: false,
      clientid: null,
      subdomain: null,
      header: {
        left: 'prev,next today',
        center: 'title',
      },
      defaultView: 'listWeek',
      calendarWeekends: true,
      buttonText: {
        today: '今日',
        dayGridWeek: '予定リスト'
      },
      fileSelected: null,
      isOpenFileList: false,
      views: {
        dayGridCustomDay: {
          type: 'dayGrid',
          duration: { days: 3 },
          buttonText: '予定リスト'
        }
      },
      isFilterLoading: false,
      now: new Date(),
      drive_info: {},
      isCreated: false,
      isTask: false,
    }
  },
  computed: {
    ...mapState('auth', ['user', 'users', 'calendarEventHistory', 'calendarSettings', 'calendarBookMarks', 'usersStatusAPI', 'isGoogleDriveAuth']),
    ...mapState('calendar', ['events', 'schedules', 'isScheduleLoading', 'isScheduleAllLoading', 'userData', 'eventFileGroup', 'eventGroup']),
    ...mapState('task', ['taskList', 'isFileChanging', 'trelloBoardList', 'trelloListList', 'trelloCardList']),
    isDriveInfoCreated () {
      return this.isCreated
    }
  },
  created () {
    this.$store.dispatch('calendar/getEventFileGroup')
    this.$store.dispatch('calendar/getEventGroup')
    this.$store.dispatch('auth/getUserCalendarSetting', null)
    this.$store.dispatch('auth/getCalendarBookMark', null)
    this.$store.dispatch('auth/getUserCalendarEventHistory', null)
    if (this.schedules.length === 0) {
      this.$store.dispatch('calendar/getSchedules', {
        year     : this.now.getFullYear(),
        month    : this.now.getMonth() + 1,
        day      : this.now.getDate(),
        category : 'week'
      })
    }
    if (this.taskList.length === 0) {
      this.$store.dispatch('task/getUserTask')
      this.$store.dispatch('task/getTrelloList')
      this.$store.dispatch('task/getTrelloBoard')
    }
  },
  mounted () {
    if (this.$route.query.msoffice) {
      alert('連携が完了いたしました。同期を行いますので、再読み込みいたします。')
      location.href = '/dashboard/calendar'
    } else if (this.$route.query.error_msoffice) {
      alert('エラーが発生いたしました。\nOffice365のアカウントが正しく認証されているか確認をお願いいたします。')
      location.href = '/dashboard/calendar'
    } else if (this.$route.query.cybozu_garoon) {
      alert('連携が完了いたしました。同期を行いますので、再読み込みいたします。')
      location.href = '/dashboard/calendar'
    } else if (this.$route.query.error) {
      alert('エラーが発生いたしました。\nクライアントID / サブドメイン / シークレットIDが正しいかどうか確認をお願い致します。')
      location.href = '/dashboard/calendar'
    }
    this.getRenkei()
    setTimeout(() => {this.getRenkei()}, 1000)
    setTimeout(() => {this.getRenkei()}, 2000)
    this.getDriveInfo()
  },
  watch: {
    isScheduleAllLoading () {
      // 全ユーザーの予定を再読み込みする
      if (this.isScheduleAllLoading) {
        let category = document.getElementsByClassName('fc-button-group')[1].getElementsByClassName('fc-button-active')[0].innerHTML;
        this.$store.dispatch('calendar/getSchedules', {
          year     : this.now.getFullYear(),
          month    : this.now.getMonth() + 1,
          day      : this.now.getDate(),
          category : category.replace('月', 'month').replace('週', 'week').replace('日', 'day')
        })
        this.$store.dispatch('task/getUserTask')
        this.$store.dispatch('task/getTrelloList')
        this.$store.dispatch('task/getTrelloBoard')
      }
    }
  },
  methods: {
    reloadCybozuOffice () {
      alert('連携用の設定を保存いたしました。スケジュールの同期には数分かかります。同期がされない場合は、設定内容が正しいか確認をお願い致します。再読み込みします。')
      location.reload()
    },
    getURLAPI () {
      if (process.env.NODE_ENV === 'development') {
        return 'https://localhost:8000'
      } else if (process.env.NODE_ENV === 'staging') {
        return 'https://w2.ndr-staging.work'
      } else if (process.env.NODE_ENV === 'third') {
        return 'https://robottte.hr-monster.io'
      } else {
        return 'https://hr-monster.io'
      }
    },
    getRenkei () {
      let us = null
      for (const u of this.users) {
        if (u.user_hash === this.user.userHash) {
          if (u.is_google_calendar_auth) {
            this.authType = 'google'
          } else if (u.is_cybozu_office_auth) {
            this.authType = 'cybozu'
          } else if (u.is_garoon_auth) {
            this.authType = 'garoon'
          } else if (u.is_msoffice_auth) {
            this.authType = 'msoffice'
          } else if (u.is_gsession_auth) {
            this.authType = 'gsession'
          } else if (u.is_lineworks_auth) {
            this.authType = 'lineworks'
          } else if (u.is_nolinkage_auth) {
            this.authType = 'nolinkage'
          }
        }
      }
      // スーパーユーザーの場合は他社のアカウント連携状況が見れるように表示しておく
      if (this.user.isAgent && this.user.companyID != '32217bf93d824aec3888413722f41a91') {
        this.authType = 'google'
        return 'スーパーユーザー（他社アカウントにいるため予定作成などしないでください）'
      } else {
        return null
      }
    },
    openSettings () {
      if (this.authType === 'google') {
        this.isModalGoogle = true
      } else if (this.authType === 'cybozu') {
        this.isModalCybozuOffice = true
      } else if (this.authType === 'garoon') {
        this.isModalGaroon = true
      } else if (this.authType === 'msoffice') {
        this.isModalMSOffice = true
      } else if (this.authType === 'gsession') {
        this.isModalGroupSession = true
      } else if (this.authType === 'lineworks') {
        this.isModalLineWorks = true
      } else if (this.authType === 'nolinkage') {
        this.isModalNoLinkage = true
      }
    },
    changeSchedules (date) {
      let category = document.getElementsByClassName('fc-button-group')[1].getElementsByClassName('fc-button-active')[0].innerHTML      
      if ( this.now.getFullYear() !== date.getFullYear()
        || this.now.getMonth()    !== date.getMonth()
        || this.now.getDate()     !== date.getDate()
      ) {
        this.now = date
        this.$store.dispatch('calendar/getSchedules', {
          year     : this.now.getFullYear(),
          month    : this.now.getMonth() + 1,
          day      : this.now.getDate(),
          category : category.replace('月', 'month').replace('週', 'week').replace('日', 'day')
        })
      }
    },
    changeTaskSchedules (date, data) {
      if ( this.now.getFullYear() !== date.getFullYear()
        || this.now.getMonth()    !== date.getMonth()
        || this.now.getDate()     !== date.getDate()
      ) {
        this.now = date
        this.$store.dispatch('calendar/getSchedules', {
          year     : this.now.getFullYear(),
          month    : this.now.getMonth() + 1,
          day      : this.now.getDate(),
          category : data=='forward' ? 'weekReturn' : 'week'
        })
      }
    },
    changeShowEvent (cs) {
      this.$store.dispatch('auth/updateUserCalendarSetting', {
        pk: cs.pk,
        user: cs.user,
        calendar_user: cs.calendar_user,
        is_check: cs.is_check,
        background_color: cs.background_color,
        color: cs.color
      })
    },
    // 自分の予定は保存しない, ON/OFF切り替えのみ
    changeShowEventSelf (isSelfCheck) {
      this.isSelfCheck = isSelfCheck
    },
    eventPositioned (info) {
      if (info.view.viewSpec.type === 'listWeek') {
        let els = document.querySelectorAll('td.fc-widget-header')
        for (let e of els) {
          e.colSpan = '4'
        }
      }
    },
    eventRender (info) {
      let fileRef = null
      for (const e of this.eventGroup) {
        if (e.calendar_id === info.event.id) fileRef = e
      }
      let memberList = ''
      let declinedNum = 0
      let acceptedNum = 0
      let tentativeNum = 0
      let needsActionNum = 0
      if (info.event.extendedProps.calendarType === 'google') {
        for (const ats of info.event.extendedProps.attendees) {
          memberList += ats.email + ' '
          switch (ats.responseStatus) {
            case 'accepted':
              acceptedNum++
              break
            case 'tentative':
              tentativeNum++
              break
            case 'needsAction':
              needsActionNum++
              break
            case 'declined':
              declinedNum++
              break
          }
        }
      }
      let tag  =  null
      if (fileRef) {
        if (info.view.viewSpec.type === 'listWeek') {
          tag ='<div style="padding-left: 12px; width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; min-height: 24px;"><span class="mdi mdi-file-document" style="margin-right: 4px;"></span>添付ファイルあり</div>'
        } else {
          tag ='<div style="width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; min-height: 24px;"><span class="mdi mdi-file-document" style="margin-right: 4px;"></span>添付ファイルあり</div>'
        }
      } else {
        if (info.view.viewSpec.type === 'listWeek') {
          tag = '<div style="padding-left: 12px; width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; min-height: 24px;"><span class="mdi mdi-border-none-variant" style="margin-right: 4px;"></span>添付ファイルなし</div>'
        } else {
          tag = '<div style="width: 100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; min-height: 24px;"><span class="mdi mdi-border-none-variant" style="margin-right: 4px;"></span>添付ファイルなし</div>'
        }
      }
      if (memberList != '') {
        if (info.view.viewSpec.type === 'listWeek') {
          tag +='<div style="padding-left: 12px; width: 100%; white-space: pre-wrap; height: 150px; overflow: hidden;"><span class="mdi mdi-account-box-multiple" style="margin-right: 4px;"></span>参加者  <span class="mdi mdi-calendar-multiple-check" style="margin-right: 4px;"></span>' + acceptedNum + ' <span class="mdi mdi-calendar-question" style="margin-right: 4px;"></span>' + tentativeNum + ' <span class="mdi mdi-calendar-remove" style="margin-right: 4px;"></span>' + declinedNum + ' <span class="mdi mdi-flag-variant-outline" style="margin-right: 4px;"></span>' + needsActionNum + '<br>' + memberList + '</div>'
        } else {
          tag +='<div style="width: 100%; white-space: pre-wrap;"><span class="mdi mdi-account-box-multiple" style="margin-right: 4px;"></span>参加者  <span class="mdi mdi-calendar-multiple-check" style="margin-right: 4px;"></span>' + acceptedNum + ' <span class="mdi mdi-calendar-question" style="margin-right: 4px;"></span>' + tentativeNum + ' <span class="mdi mdi-calendar-remove" style="margin-right: 4px;"></span>' + declinedNum + ' <span class="mdi mdi-flag-variant-outline" style="margin-right: 4px;"></span>' + needsActionNum + '<br>' + memberList + '</div>'
        }
      } else {
        if (info.view.viewSpec.type === 'listWeek') {
          tag +='<div style="padding-left: 12px; width: 100px; white-space: pre-wrap; height: 150px; overflow: hidden;"></div>'
        }
      }
      info.el.insertAdjacentHTML('beforeend', tag)
    },
    eventClick (info) {
      this.$refs.edit.info = {
        id: info.event.id,
        title: info.event.title,
        start: info.event.start,
        end: info.event.end,
        borderColor: info.event.borderColor,
        backgroundColor: info.event.backgroundColor,
        textColor: info.event.textColor,
        eventFileRef: info.event.eventFileRef,
        description: info.event.extendedProps.description,
        calendarType: info.event.extendedProps.calendarType,
        attendees: info.event.extendedProps.attendees,
        eventJson: info.event.extendedProps.eventJson,
        startEditable: info.event.startEditable,
        invitation: info.event.extendedProps.invitation !== undefined ? info.event.extendedProps.invitation : ''
      }
      this.$refs.edit.isCardModalActive = true
    },
    isEditableCalendarSettings (u) {
      for (const cs of this.calendarSettings) {
        if (u.user_hash === cs.calendar_user) {
          return true
        }
      }
      return false
    },
    ucsEditClick (u) {
      for (const cs of this.calendarSettings) {
        if (u.user_hash === cs.calendar_user) {
          this.$refs.ucs.user = this.user
          this.$refs.ucs.pk = cs.pk
          this.$refs.ucs.calUser = cs.cal_user
          this.$refs.ucs.userHash = cs.calendar_user
          this.$refs.ucs.color = cs.background_color
          this.$refs.ucs.isCardModalActive = true
        }
      }
    },
    select (info) {
      this.$refs.create.info = {
        title: null,
        start: info.start,
        end: info.end,
        calendarType: this.authType,
        description: null,
        attendees: [],
        attendees_departments: [],
        attendees_positions: []
      }
      this.$refs.create.step = 0
      this.$refs.create.isTask = false
      this.$refs.create.isCreateFromDate = true
      this.$refs.create.isCardModalActive = true
    },
    // taskからの作成
    createEvent (task) {
      let now = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
        new Date().getHours()
      )
      let start = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
        new Date().getHours()
      )
      start.setMinutes(60)
      let end = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
        new Date().getHours()
      )
      end.setMinutes(60)
      end.setMinutes(task.time_min)
      this.$refs.create.info = {
        title: task.title,
        start: start,
        end: end,
        calendarType: this.authType,
        description: task.description,
        attendees: [],
        attendees_departments: [],
        attendees_positions: []
      }
      this.$refs.create.taskFiles = task.user_task_file
      this.$refs.create.isFileAttach = true
      this.$refs.create.step = 0
      this.$refs.create.isTask = true
      this.$refs.create.isCreateFromDate = true
      this.$refs.create.isCardModalActive = true
    },
    createRecommendEvent (info) {
      this.$refs.create.info = {
        title: null,
        memo: null,
        mtg_time_hour: 1,
        mtg_time_minute: 0,
        holiday_list: [],
        after: 1,
        user_hash: [],
        user_hash_sub: [],
        user_hash_share: [],
        user_hash_departments: [],
        user_hash_positions: [],
        method: 0,
        interval: 0,
        reminder_flg: false,
        reminder_day: 1,
        reminder_before_flg: false,
        reminder_before_minute: 30,
        reminder_member_flg: false,
        reminder_title: null,
        reminder_to: null,
        reminder_cc: null,
        reminder_content: null,
        calendarType: this.authType,
        is_AND: true
      }
      this.$refs.create.step = 0
      this.$refs.create.isTask = false
      this.$refs.create.isCreateFromDate = false
      this.$refs.create.isCardModalActive = true
    },
    createCalendarBookMark (info) {
      this.$refs.cbm.info = {
        title: null,
        memo: null,
        mtg_time_hour: 1,
        mtg_time_minute: 0,
        holiday_list: [],
        after: 1,
        user_hash: [],
        user_hash_sub: [],
        user_hash_share: [],
        user_hash_departments: [],
        user_hash_positions: [],
        method: 0,
        interval: 0,
        reminder_flg: false,
        reminder_day: 1,
        reminder_before_flg: false,
        reminder_before_minute: 30,
        reminder_member_flg: false,
        reminder_title: null,
        reminder_to: null,
        reminder_cc: null,
        reminder_content: null,
        calendarType: this.authType,
        is_AND: true
      }
      this.$refs.cbm.isCardModalActive = true
    },
    clickEventFromHistory (h) {
      this.$refs.create.info = h.parameter
      this.$refs.create.info.calendarType = this.authType
      this.$refs.create.step = 0
      this.$refs.create.after = 1
      let start_hour = parseInt(h.parameter.work_time_start, 10)
      let start_minute = parseInt((h.parameter.work_time_start * 100) - (start_hour * 100), 10)
      let end_hour = parseInt(h.parameter.work_time_end, 10)
      let end_minute = parseInt((h.parameter.work_time_end * 100) - (end_hour * 100), 10)
      // mtg_time, bufferある既存のパラメータの変換
      if (h.parameter.mtg_time_hour === undefined) {
        h.parameter.mtg_time_hour = Math.floor(h.parameter.mtg_time)
      }
      if (h.parameter.mtg_time_minute === undefined) {
        h.parameter.mtg_time_minute = parseInt((h.parameter.mtg_time - Math.floor(h.parameter.mtg_time)) * 60)
      }
      if (h.parameter.interval > 0.01 && h.parameter.interval < 3) {
        h.parameter.interval = parseInt(h.parameter.interval * 60)
      }
      this.$refs.create.start = new Date(2017, 0, 15, start_hour, start_minute)
      this.$refs.create.end = new Date(2017, 0, 15, end_hour, end_minute)
      this.$refs.create.isCreateFromDate = false
      this.$refs.create.isCardModalActive = true
    },
    handleDateClick (arg) {
      if (confirm("Would you like to add an event to " + arg.dateStr + " ?")) {
        this.calendarEvents.push({
          title: "New Event",
          start: arg.date,
          allDay: arg.allDay
        })
      }
    },
    setProfile (data, type) {
      this.$store.dispatch('auth/setProfile', {data: data, type: type})
    },
    googleAuthRedirect () {
      this.$store.dispatch('calendar/googleAuthRedirect', {email: this.user.email, username: this.user.username})
    },
    msofficeAuthRedirect () {
      const clientId = 'ace30ca4-3e64-47dc-8217-cbc5f8ce9611'
      const redirectURI = process.env.LOC_HOST + '/api/user/redirect/msoffice/'
      const scope = 'https://graph.microsoft.com/Calendars.Read https://graph.microsoft.com/Calendars.ReadWrite https://graph.microsoft.com/User.Read.All offline_access'
      location.href = 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize?response_type=code&client_id=' + clientId + '&scope=' + scope + '&redirect_uri=' + redirectURI
    },
    googleAuthRevoke () {
      this.$store.dispatch('auth/googleAuthRevoke')
    },
    changeModalCybozuOffice (flg) {
      this.isModalCybozuOffice = flg
    },
    changeModalGaroon (flg) {
      this.isModalGaroon = flg
    },
    changeModalGroupSession (flg) {
      this.isModalGroupSession = flg
    },
    changeModalLineWorks (flg) {
      this.isModalLineWorks = flg
    },
    changeModalNoLinkage (flg) {
      this.isModalNoLinkage = flg
    },
    msofficeAuthRevoke () {
      this.$store.dispatch('auth/msofficeAuthRevoke')
    },
    autoColor (c) {
      let color = hex2rgb(c)
      return autoColor(color)
    },
    async createCalendarSettings (data) {
      const color = this.colorList[Math.floor( Math.random() * (13 + 1 - 0) ) + 0].code
      try {
        await this.$store.dispatch('auth/createUserCalendarSetting', {
          user: this.user.userHash,
          calendar_user: data.user.user_hash,
          background_color: color,
          color: this.autoColor(color)
        })
        let range_category = 'week'
        if (this.$route.path.indexOf('/calendar/task') < 0) {
          // 予定調整・カレンダー画面の場合
          let category = document.getElementsByClassName('fc-button-group')[1].getElementsByClassName('fc-button-active')[0].innerHTML      
          range_category = category.replace('月', 'month').replace('週', 'week').replace('日', 'day')
        }
        await this.$store.dispatch('calendar/getSchedules', {
          year     : this.now.getFullYear(),
          month    : this.now.getMonth() + 1,
          day      : this.now.getDate(),
          category : range_category
        })
      } catch(e) {
        console.error(e)
        alert('エラーが発生いたしました。')
      }
    },
    saveCybozuOffice () {
      this.setProfile(
        {
          'cybozu_office_wsdl': this.user.cybozu_office_wsdl
        },'company')
      this.setProfile({
        'cybozu_office_id'       : this.user.cybozu_office_id,
        'cybozu_office_secret'   : this.user.cybozu_office_secret,
        'cybozu_office_uid'      : this.user.cybozu_office_uid,
        'cybozu_office_basic'    : this.user.cybozu_office_basic,
        'cybozu_office_basic_id' : this.user.cybozu_office_basic_id,
        'cybozu_office_basic_pw' : this.user.cybozu_office_basic_pw,
      },'profile')
      this.reloadCybozuOffice()
    },
    saveGaroonInit () {
      this.setProfile({
        'cybozu_id'       : this.user.cybozu_id,
        'cybozu_subdomain': this.user.cybozu_subdomain,
        'cybozu_secret'   : this.user.cybozu_secret,
      }, 'company')
      this.setProfile({
        'cybozu_login_id': this.user.cybozu_login_id,
      }, 'profile')
    },
    saveGaroon () {
      this.setProfile({
        'cybozu_login_id': this.user.cybozu_login_id,
      }, 'profile')
    },
    saveLineWorks () {
      this.setProfile({
        'lineworks_id'    : this.user.lineworks_id,
        'lineworks_secret'   : this.user.lineworks_secret,
      }, 'company')
      this.setProfile({
        'lineworks_login_id': this.user.lineworks_login_id,
      }, 'profile')
    },
    saveGroupSession () {
      this.setProfile({
        'group_session_id'     : this.user.group_session_id,
        'group_session_pw'     : this.user.group_session_pw,
        'group_session_domain' : this.user.group_session_domain,
      }, 'profile')
      this.reloadCybozuOffice()
    },
    saveNoLinkage () {
      this.$store.dispatch('auth/setUsers',{
        'email': this.user.email,
        'is_use_calendar': true
      }).then(() => {
        alert('カレンダーの利用を開始します。再読み込みします。')
        location.reload()
      })
    },
    deleteGaroon () {
      this.$store.dispatch('auth/deleteGaroon')
    },
    deleteLineWorks () {
      this.$store.dispatch('auth/deleteLineWorks')
    },
    deleteCybozuOffice () {
      this.$store.dispatch('auth/deleteCybozuOffice')
    },
    deleteGroupSession () {
      this.setProfile({
        'group_session_id'     : null,
        'group_session_pw'     : null,
        'group_session_domain' : null,
      }, 'profile')
      this.reloadCybozuOffice()
    },
    deleteNoLinkage () {
      this.$store.dispatch('calendar/deleteNoLinkageCalendars', {user: this.user})
      this.$store.dispatch('auth/setUsers',{
        'email': this.user.email,
        'is_use_calendar': false
      }).then(() => {
        alert('カレンダーの利用を終了します。再読み込みします。')
        location.reload()
      })
    },
    createUserTask (data) {
      this.$store.dispatch('task/createUserTask', data)
        .then((retData) => {
          // file作成
          for (const d of data.file) {
            let attachedFile = new FormData()
            attachedFile.append('attached_file', d)
            attachedFile.append('filename', d.name)
            attachedFile.append('user_task', retData.pk)
            this.$store.dispatch('task/createUserTaskFile', attachedFile)
          }
        })
    },
    sendUserTask (data, members) {
      for (const member of members) {
        let taskData = this.$_.cloneDeep(data)
        taskData.user = member.user_hash
        taskData.is_bookmark = false
        taskData.is_send = true
        delete taskData.pk
        this.$store.dispatch('task/createUserTask', taskData)
          .then((sendData) => {
            // ファイル添付
            for (const d of taskData.user_task_file) {
              let attachedFile = new FormData()
              attachedFile.append('send_file', d.pk)
              attachedFile.append('filename', d.filename)
              attachedFile.append('user_task', sendData.pk)
              this.$store.dispatch('task/createUserTaskFile', attachedFile)
            }
            // data作成後ログを作成、全部作成終わったらログ作成
            let createData = {
              user_task: data.pk,
              send_user_task: sendData.pk,
              send_user: member.user_hash,
              created_user: data.user
            }
            this.$store.dispatch('task/createUserTaskLog', createData)
          })
      }
    },
    updateUserTask (data) {
      this.$store.dispatch('task/updateUserTask', data)
    },
    deleteUserTask (data) {
      this.$store.dispatch('task/deleteUserTask', data)
    },
    createUserTaskFile (data) {
      for (const d of data.files) {
        let attachedFile = new FormData()
        attachedFile.append('attached_file', d)
        attachedFile.append('filename', d.name)
        attachedFile.append('user_task', data.pk)
        this.$store.dispatch('task/createUserTaskFile', attachedFile)
      }
    },
    deleteUserTaskFile (pk) {
      this.$store.dispatch('task/deleteUserTaskFile', pk)
    },
    updateUserTaskLog (logs) {
      for (const log of logs) {
        log.is_read = true
        this.$store.dispatch('task/updateUserTaskLog', log)
      }
    },
    setFolder (folderId, folderName, mimeType, folderPath) {
      let info =  {
        id: folderId,// フォルダID
        name: folderName,// フォルダ名
        mimeType: mimeType,// MIMEタイプ
        folderPath: folderPath// フォルダパス
      }
      this.drive_info = (
        this.drive_info ?
        Object.assign(this.drive_info, info) :
        info
      )
    },
    createDriveInfo () {
      let driveInfo = {
        drive_info: this.drive_info
      }
      if (!this.isCreated) {
        this.isCreated = true
        this.$store.dispatch('calendar/createGoogleDriveAttachmentInfo', driveInfo)
      } else {
        this.$store.dispatch('calendar/updateGoogleDriveAttachmentInfo', driveInfo)
      }
    },
    closeModalGoogle (flg) {
      this.isModalGoogle = flg
    },
    /** drive_infoをgetする関数 */ 
    async getDriveInfo () {
      await this.$store.dispatch('auth/getGoogleDriveAuthStatus')
      if (this.isGoogleDriveAuth && !this.user.isAgent) {
        const result = await this.$store.dispatch('calendar/getGoogleDriveAttachmentInfo')
        if (result) {
          this.isCreated = true
          this.drive_info = result.drive_info
        }
      }
    }
  }
}
</script>

<style lang='scss' scoped>

.tab-container {
  display: flex;
  flex-direction: row;
  margin: 0;
  height: 100vh;
  width: 100%;
  background: #fefefe;
  position: relative;
}
.main-menu {
  width: 250px;
  height: calc(100vh - 80px);
  background: #fefefe;
  -webkit-box-shadow: 2px 0px 4px -1px rgba(0,0,0,0.31);
  -moz-box-shadow: 2px 0px 4px -1px rgba(0,0,0,0.31);
  box-shadow: 2px 0px 4px -1px rgba(0,0,0,0.31);
  overflow: scroll;
}
.main-menu > .menu-title {
  width: 100%;
  padding: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.main-body {
  height: calc(100vh - 80px);
  width: calc(100% - 250px);
}
.member {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%; text-align: left; padding-left: 24px;
}
.-pointer {
  cursor: pointer;
}
.member:hover {
  background-color:rgba(240, 200, 200, 0.8);
}
.header-box {
  width: calc(100% - 80px);
  margin: 10px 40px;
  margin-bottom: 10px;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: dotted 6px #323;
  flex-wrap: wrap;
}
.header-menu {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
}
.calendar-view {
  padding: 24px;
  margin: 0 auto;
  max-width: 900px;
  height: calc(100% - 200px);
}
.drawer-menu {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 40%;
  min-width: 400px;
  background: #FEFEFE;
  padding: 16px;
  z-index: 201;
}
.drawer-back {
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  z-index: 200; top: 0;
}
.right-enter-active, .right-leave-active {
  transform: translate(0px, 0px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.right-enter, .right-leave-to {
  transform: translateX(100vw) translateX(0px);
}
.my-calendar {
  display: flex;
  margin: 4px;
  padding-left: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Calendar/CalendarView.vue